export const baseRules = {
  title: [{ required: true, message: '请输入标题', tirgger: 'blur' }],
  type: [{ required: true, message: '请选择类型', tirgger: 'change' }],
  content: [{ required: true, message: '请输入内容', tirgger: 'blur' }],
};
